export default "__VITE_ASSET__D4K5bPK1__"